import { AppPalette } from '../../colors'

export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      height: '42px',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      ['&:not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline']: {
        borderColor: AppPalette.GREY.highlight_lighter
      }
    },
    notchedOutline: {
      borderColor: AppPalette.GREY.highlight_lighter
    },
    input: {
      padding: '12px 16px',
      '&::placeholder': {
        color: AppPalette.GREY.darker
      }
    }
  }
}
